import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { deofuscate } from '@/utils/obfuscation';
import { Breadcrumbs } from '@/shared/breadcrum/breadcrum.component';
import { Variant } from '@/interfaces/transaction-result';

@Component({
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css'],
})
export class ResultComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
  ) { }

  email: string = '';
  id: number = 0;
  variant: Variant = 'success';
  message: string = '';
  messageBold: string = '';
  subtitle: string = 'La solicitud de licencia ha sido aprobada';

  breadcrums: Breadcrumbs = [
    { text: 'Inicio', path: '/dashboard' },
    { text: 'Aprobar Solicitudes', path: '/license/approve' },
  ]

  ngOnInit() {
    this.route.params.pipe().subscribe(({ ofuscatedData, ofuscatedResult }) => {
      const paramsWithId = deofuscate(ofuscatedData);
      const params = deofuscate(ofuscatedResult);

      this.id = paramsWithId.id || 0;
      this.email = params.email || '';
      this.variant = params.variant || 'success';
      if (this.variant === 'success') {
        this.message = `Una copia de su solicitud fue enviada al correo electrónico ${this.email}`;
        this.messageBold = `N° solicitud: ${this.id}`;
      }
      if (this.variant === 'failure') {
        this.subtitle = 'Hubo un problema y no hemos podido aprobar la solicitud. Por favor intenta de nuevo.';
      }
    });
  }

}
